import { render, staticRenderFns } from "./zjlCourse.vue?vue&type=template&id=63e93c52&scoped=true"
import script from "./zjlCourse.vue?vue&type=script&lang=js"
export * from "./zjlCourse.vue?vue&type=script&lang=js"
import style0 from "./zjlCourse.vue?vue&type=style&index=0&id=63e93c52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e93c52",
  null
  
)

export default component.exports